import {Component, OnInit, SimpleChanges, Input, ElementRef, ViewChild} from '@angular/core';
import { SelfFill } from '../../../../models/SelfFill.model';
import {CommonHelper} from '../../../../shared/helpers/CommonHelper';

@Component({
    selector: 'modal-compare-data',
    templateUrl: './modalCompareData.component.html',
    styleUrls: ['./modalCompareData.component.css']
})
export class ModalCompareDataComponent implements OnInit {
    @Input() selfFill: any;
    selfFillConsultantPreviousData = new SelfFill();
    selfFillConsultantUpdatedData = new SelfFill();
    selfFillConsultantPreviousDataValid: boolean = true;
    selfFillConsultantUpdatedDataValid: boolean = true;
    hash: string;
    birthDayMask = [
        /[0-3]/,
        /[0-9]/,
        '/',
        /[0-3]/,
        /[0-9]/,
        '/',
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
    ];

    constructor(
        public commonHelper: CommonHelper
    ) {}

    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges) {
        if(changes.selfFill){
            if(changes.selfFill.currentValue) {
                this.hash =  changes.selfFill.currentValue.hash;
                this.changeSelfFillConsultantPreviousData(changes.selfFill.currentValue);
                this.changeSelfFillConsultantUpdatedData(changes.selfFill.currentValue);
            }
        }
    }

    validateEquality(first, second) {
        return first != second ? first : null;
    }

    validRender(first , second) {
        if(!first && !second)
            return false;
        if(first == second)
            return false;
        return true;
    }

    changeSelfFillConsultantPreviousData(selfFill) {
        if((selfFill.previousData || selfFill.previousData != {}) && (selfFill.updatedData || selfFill.updatedData != {})) {
            this.selfFillConsultantPreviousData.name = this.validateEquality(selfFill.previousData.name, selfFill.updatedData.name);
            this.selfFillConsultantPreviousData.email = this.validateEquality(selfFill.previousData.email, selfFill.updatedData.email);
            if(selfFill.previousData.emergency && selfFill.updatedData.emergency)
                this.selfFillConsultantPreviousData.emergency = this.validateEquality(selfFill.previousData.emergency, selfFill.updatedData.emergency);
            else
                this.selfFillConsultantPreviousData.emergency = null;
            if(selfFill.previousData.personal && selfFill.updatedData.personal) {
                const previousBorn = selfFill.previousData.personal.born ? new Date(selfFill.previousData.personal.born).toLocaleDateString("pt-br",  {day: "numeric", month: "numeric", year: "numeric"}) : null;
                this.selfFillConsultantPreviousData.personal.rg = this.validateEquality(selfFill.previousData.personal.rg, selfFill.updatedData.personal.rg);
                this.selfFillConsultantPreviousData.personal.cpf = this.validateEquality(selfFill.previousData.personal.cpf, selfFill.updatedData.personal.cpf);
                this.selfFillConsultantPreviousData.personal.born = this.validateEquality(previousBorn, selfFill.updatedData.personal.born);
                this.selfFillConsultantPreviousData.personal.sex = this.validateEquality(selfFill.previousData.personal.sex, selfFill.updatedData.personal.sex);
                this.selfFillConsultantPreviousData.personal.civilStatus = this.validateEquality(selfFill.previousData.personal.civilStatus, selfFill.updatedData.personal.civilStatus);
                this.selfFillConsultantPreviousData.personal.motherName = this.validateEquality(selfFill.previousData.personal.motherName, selfFill.updatedData.personal.motherName);
                this.selfFillConsultantPreviousData.personal.fatherName = this.validateEquality(selfFill.previousData.personal.fatherName, selfFill.updatedData.personal.fatherName);
                this.selfFillConsultantPreviousData.personal.homePhone = this.validateEquality(selfFill.previousData.personal.homePhone, selfFill.updatedData.personal.homePhone);
                this.selfFillConsultantPreviousData.personal.cellPhone = this.validateEquality(selfFill.previousData.personal.cellPhone, selfFill.updatedData.personal.cellPhone);
                this.selfFillConsultantPreviousData.personal.cep = this.validateEquality(selfFill.previousData.personal.cep, selfFill.updatedData.personal.cep);
                this.selfFillConsultantPreviousData.personal.address = this.validateEquality(selfFill.previousData.personal.address, selfFill.updatedData.personal.address);
                this.selfFillConsultantPreviousData.personal.number = this.validateEquality(selfFill.previousData.personal.number, selfFill.updatedData.personal.number);
                this.selfFillConsultantPreviousData.personal.complement = this.validateEquality(selfFill.previousData.personal.complement, selfFill.updatedData.personal.complement);
                this.selfFillConsultantPreviousData.personal.district = this.validateEquality(selfFill.previousData.personal.district, selfFill.updatedData.personal.district);
                this.selfFillConsultantPreviousData.personal.city = this.validateEquality(selfFill.previousData.personal.city, selfFill.updatedData.personal.city);
                this.selfFillConsultantPreviousData.personal.country = this.validateEquality(selfFill.previousData.personal.country, selfFill.updatedData.personal.country);
                this.selfFillConsultantPreviousData.personal.state = this.validateEquality(selfFill.previousData.personal.state, selfFill.updatedData.personal.state);
            } else
                this.selfFillConsultantPreviousDataValid = false;
        }
    }

    changeSelfFillConsultantUpdatedData(selfFill) {
        if((selfFill.previousData || selfFill.previousData != {}) && (selfFill.updatedData || selfFill.updatedData != {})) {
            this.selfFillConsultantUpdatedData.name = this.validateEquality(selfFill.updatedData.name, selfFill.previousData.name);
            this.selfFillConsultantUpdatedData.email = this.validateEquality(selfFill.updatedData.email, selfFill.previousData.email);
            if(selfFill.previousData.emergency && selfFill.updatedData.emergency)
                this.selfFillConsultantUpdatedData.emergency = this.validateEquality(selfFill.updatedData.emergency, selfFill.previousData.emergency);
            else
                this.selfFillConsultantUpdatedData.emergency = null;
            if(selfFill.previousData.personal && selfFill.updatedData.personal) {
                const updatedBorn = selfFill.updatedData.personal.born ? new Date(selfFill.updatedData.personal.born).toLocaleDateString("pt-br",  {day: "numeric", month: "numeric", year: "numeric"}) : null;
                this.selfFillConsultantUpdatedData.personal.rg = this.validateEquality(selfFill.updatedData.personal.rg, selfFill.previousData.personal.rg);
                this.selfFillConsultantUpdatedData.personal.cpf = this.validateEquality(selfFill.updatedData.personal.cpf, selfFill.previousData.personal.cpf);
                this.selfFillConsultantUpdatedData.personal.born = this.validateEquality(updatedBorn, selfFill.previousData.personal.born);
                this.selfFillConsultantUpdatedData.personal.sex = this.validateEquality(selfFill.updatedData.personal.sex, selfFill.previousData.personal.sex);
                this.selfFillConsultantUpdatedData.personal.civilStatus = this.validateEquality(selfFill.updatedData.personal.civilStatus, selfFill.previousData.personal.civilStatus);
                this.selfFillConsultantUpdatedData.personal.motherName = this.validateEquality(selfFill.updatedData.personal.motherName, selfFill.previousData.personal.motherName);
                this.selfFillConsultantUpdatedData.personal.fatherName = this.validateEquality(selfFill.updatedData.personal.fatherName, selfFill.previousData.personal.fatherName);
                this.selfFillConsultantUpdatedData.personal.homePhone = this.validateEquality(selfFill.updatedData.personal.homePhone, selfFill.previousData.personal.homePhone);
                this.selfFillConsultantUpdatedData.personal.cellPhone = this.validateEquality(selfFill.updatedData.personal.cellPhone, selfFill.previousData.personal.cellPhone);
                this.selfFillConsultantUpdatedData.personal.cep = this.validateEquality(selfFill.updatedData.personal.cep, selfFill.previousData.personal.cep);
                this.selfFillConsultantUpdatedData.personal.address = this.validateEquality(selfFill.updatedData.personal.address, selfFill.previousData.personal.address);
                this.selfFillConsultantUpdatedData.personal.number = this.validateEquality(selfFill.updatedData.personal.number, selfFill.previousData.personal.number);
                this.selfFillConsultantUpdatedData.personal.complement = this.validateEquality(selfFill.updatedData.personal.complement, selfFill.previousData.personal.complement);
                this.selfFillConsultantUpdatedData.personal.district = this.validateEquality(selfFill.updatedData.personal.district, selfFill.previousData.personal.district);
                this.selfFillConsultantUpdatedData.personal.city = this.validateEquality(selfFill.updatedData.personal.city, selfFill.previousData.personal.city);
                this.selfFillConsultantUpdatedData.personal.country = this.validateEquality(selfFill.updatedData.personal.country, selfFill.previousData.personal.country);
                this.selfFillConsultantUpdatedData.personal.state = this.validateEquality(selfFill.updatedData.personal.state, selfFill.previousData.personal.state);
            } else
                this.selfFillConsultantUpdatedDataValid = false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/views/consultants/components/modalCompareData/modalCompareData.component.ts